import React from 'react'
import RightBar from '../RightBar/RightBar'
import { useLastNewsPage } from 'modules/website/hooks/useThisIssuePage';

export default function ThisIssue(props) {
    const { mainPage, startCollapse } = props;
    const { isLoading, isError, payload, error } = useLastNewsPage();
    return (
        !isError && !isLoading && payload && (
            <RightBar details={payload} mainPage={mainPage} startCollapse={startCollapse}/>
        )
    )
}
